document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.download-all-btn');
  if (!btn) return;

  const btnTxt = btn.querySelector('.txt');
  if (!btnTxt) return;

  const docsBlock = btn.closest('.product-block-pcw-docs-field');
  if (!docsBlock) return;

  const pdfLinks = Array.from(docsBlock.querySelectorAll('a[href*=".pdf"]'));
  if (!pdfLinks.length) return;

  btn.addEventListener('click', async function () {
    const originalText = btn.textContent;
    btn.disabled = true;
    btnTxt.textContent = btn.dataset.loading || 'Loading...';

    try {
      const zip = new JSZip();
      const productName = document.querySelector('h1')?.textContent?.trim() || 'documents';
      const slug = productName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

      await Promise.all(pdfLinks.map(async (link) => {
        const label = link.querySelector('span')?.textContent?.trim() || 'document';
        const response = await fetch(link.href);
        const blob = await response.blob();
        zip.file(label + '.pdf', blob);
      }));

      const content = await zip.generateAsync({ type: 'blob' });
      const url = URL.createObjectURL(content);
      const a = document.createElement('a');
      a.href = url;
      a.download = slug + '-documents.zip';
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
    } finally {
      btn.disabled = false;
      btnTxt.textContent = originalText;
    }
  });
});